import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { FunctionService, LanguageService, ThemeService } from 'vhobjects-service/src/services';
import { ChooseIconComponent } from 'vhobjects-service';
import { AtwMediaListAdmin } from 'vhobjects-admin';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'atw-media-list-config',
  templateUrl: './media-list-config.component.html',
  styleUrls: ['./media-list-config.component.scss']
})
export class AtwMediaListConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  currentViewAll: any = {}; // biến xác định mở rộng tất cả hay theo thuộc tính
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  styles_field = [
    {
      title: 'dieu_chinh_noi_dung',
      index: 1,
    },
  ];
  public matIconArrows: any = [
    {
      icon_left: 'keyboard_arrow_left',
      icon_right: 'keyboard_arrow_right',
    },
    {
      icon_left: 'arrow_back',
      icon_right: 'arrow_forward',
    },
    {
      icon_left: 'arrow_left',
      icon_right: 'arrow_right',
    },
    {
      icon_left: 'keyboard_double_arrow_left',
      icon_right: 'keyboard_double_arrow_right',
    },
  ];

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public functionService: FunctionService,
    private vhEventMediator: VhEventMediator,
    public themeService: ThemeService,
    private nzModalService: NzModalService,
    private languageService: LanguageService,
    private matDialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  openModalEdit() {
    const modal: NzModalRef = this.nzModalService.create({
      nzTitle: this.languageService.translate('chinh_sua_noi_dung'),
      nzWidth: '80%',
      nzContent: AtwMediaListAdmin,
      nzComponentParams: {
        data: {
          ...this.objectChoosing,
        },
        type: 'page'
      },
      nzFooter: null,
    });
    modal.afterClose.subscribe(result => {
      this.vhEventMediator.notifyOnConfigChanged({
        status: 'config-changed',
        code: this.objectChoosing._id,
      });
    });
  }

  /*--------- Thay đổi mũi tên điều hướng trang -------------------*/
  onChangeArrows(arrow, type: 'pagination' | 'video_youtube') {
    switch (type) {
      case 'pagination':
        this.staticdata.icon_prev = arrow.icon_left;
        this.staticdata.icon_next = arrow.icon_right; 
        break;
      case 'video_youtube': 
        this.staticdata.video.icon_prev = arrow.icon_left;
        this.staticdata.video.icon_next = arrow.icon_right; 
        break;
    }
    this.updateStaticData();
  }

  openDialogChooseIcon(type: 'video_close') {
    const dialogRef = this.matDialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        switch (type) {
          case 'video_close':
            this.staticdata.video.icon_close = result.icon;
            break;
        }
        this.updateStaticData();
      }
    });
  }

  /**
   *Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        // console.log('updateClass', bool);
      })
  }

  /**
   * Hàm update object vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {
        // console.log('updateObject', bool);
      })
  }

  /**
   * Hàm update object vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool: any) => {
        // console.log('updateObject', bool);
      })
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(
      this.objectChoosing._id, 
      { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata }
    ).then((bool: any) => {
      // console.log('updateObject', bool);
    })
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true, menu2: false, menu3: false, menu4: false, menu5: false, menu6: false,
    menu7: false, menu8: false, menu16: false, menu17: false
  };
  openMapSub: { [name: string]: boolean } = {
    submenu1: true, submenu2: false
  };

  openHandler(value: string, isSub = false): void {
    const targetMap = isSub ? this.openMapSub : this.openMap;
    Object.keys(targetMap).forEach(key => {
      if (key !== value) targetMap[key] = false;
    });
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['media-list']['width'] = event.width + 'px';
    if (event.height) this.class['media-list']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged(
      { status: 'update-object-selected-ruler', code: this.objectChoosing._id }
    );
    this.updateClass();
  }
}
